import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { AccountMerge } from '@mews-commander/modules/src/accounts/modules/accountMerge';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Accounts/GuestMatchAndMerge')({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.matchAndMergeDuplicateGuestProfilesEnabled);
    },
    component: AccountMerge,
    staticData: {
        routeName: RouteName.AccountMatchAndMerge,
        owner: MewsTeam.Accounts,
        title: TextKey.AccountMergePageTitle,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
